document.addEventListener(
  "DOMContentLoaded",
  () => {

    const sections =
      document.querySelectorAll(
        ".editorial-hero-v2"
      );

    if (!sections.length) return;

    const prefersReducedMotion =
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

    sections.forEach((section) => {

      const topHeading =
        section.querySelector(
          "[data-top-heading]"
        );

      const bottomHeading =
        section.querySelector(
          "[data-bottom-heading]"
        );

      const image =
        section.querySelector(
          ".editorial-hero-v2__image"
        );

      const badge =
        section.querySelector(
          ".editorial-hero-v2__badge"
        );

      /* =====================================
         SCROLL SEPARATION EFFECT
      ===================================== */

      const updateHero =
        () => {

          const rect =
            section.getBoundingClientRect();

          const windowHeight =
            window.innerHeight;

          /*
          progress:
          0 = hero enters
          1 = hero leaves
          */

          const progress =
            Math.max(
              0,
              Math.min(
                1,
                (windowHeight - rect.top)
                /
                (windowHeight + rect.height)
              )
            );

          /*
          TOP MOVES UP
          */

          const topShift =
            progress * -180;

          /*
          BOTTOM MOVES DOWN
          */

          const bottomShift =
            progress * 180;

          section.style.setProperty(
            "--hero-top-shift",
            `${topShift}px`
          );

          section.style.setProperty(
            "--hero-bottom-shift",
            `${bottomShift}px`
          );

        };

      updateHero();

      window.addEventListener(
        "scroll",
        updateHero,
        {
          passive: true
        }
      );

      window.addEventListener(
        "resize",
        updateHero
      );

      /* =====================================
         MOUSE PARALLAX
      ===================================== */

      if (
        prefersReducedMotion
      ) return;

      section.addEventListener(
        "mousemove",
        (event) => {

          const rect =
            section.getBoundingClientRect();

          const x =
            (
              event.clientX
              -
              rect.left
            )
            /
            rect.width;

          const y =
            (
              event.clientY
              -
              rect.top
            )
            /
            rect.height;

          const moveX =
            (x - 0.5) * 40;

          const moveY =
            (y - 0.5) * 40;

          if (image) {

            image.style.transform =
              `
              translate3d(
                ${moveX * 0.35}px,
                ${moveY * 0.35}px,
                0
              )
              `;
          }

          if (badge) {

            badge.style.transform =
              `
              translate3d(
                ${moveX * 0.8}px,
                ${moveY * 0.8}px,
                0
              )
              `;
          }

        }
      );

      /* =====================================
         RESET
      ===================================== */

      section.addEventListener(
        "mouseleave",
        () => {

          if (image) {

            image.style.transform =
              "translate3d(0,0,0)";
          }

          if (badge) {

            badge.style.transform =
              "translate3d(0,0,0)";
          }

        }
      );

      /* =====================================
         FADE IN
      ===================================== */

      const observer =
        new IntersectionObserver(

          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  entry.isIntersecting
                ) {

                  section.classList.add(
                    "editorial-hero-v2--visible"
                  );

                }

              }
            );

          },

          {
            threshold: 0.2
          }

        );

      observer.observe(section);

    });

  }
);